const IconFolio = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.5 13.333 6.225 9.61a1.51 1.51 0 0 1 2.134 0l3.308 3.308m0 0 1.25 1.25m-1.25-1.25 1.641-1.642a1.51 1.51 0 0 1 2.134 0l2.058 2.058"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M10 2.083c-3.525 0-5.287 0-6.456.999q-.249.212-.462.462C2.083 4.713 2.083 6.475 2.083 10s0 5.287.999 6.456q.212.249.462.462c1.169.999 2.931.999 6.456.999s5.287 0 6.456-.999q.249-.212.462-.462c.999-1.169.999-2.931.999-6.456M17.917 5H15m0 0h-2.917M15 5V2.083M15 5v2.917"
    ></path>
  </svg>
);

const IconFolioStar = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="#DA558D"
      d="M8.003 1.667a.5.5 0 0 0-.45.276L5.835 5.378l-4.078.628a.5.5 0 0 0-.277.847L4.3 9.674l-.627 4.083a.5.5 0 0 0 .725.52L8 12.397l3.602 1.88a.5.5 0 0 0 .726-.52l-.629-4.083 2.821-2.82a.5.5 0 0 0-.277-.848l-4.078-.628-1.718-3.435a.5.5 0 0 0-.444-.276"
    ></path>
  </svg>
);

// คู่ outline ของ IconFolioStar — สถานะยังไม่ปักดาว (สีคุมจาก className ผ่าน currentColor)
const IconFolioStarOutline = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
      d="M8.003 1.667a.5.5 0 0 0-.45.276L5.835 5.378l-4.078.628a.5.5 0 0 0-.277.847L4.3 9.674l-.627 4.083a.5.5 0 0 0 .725.52L8 12.397l3.602 1.88a.5.5 0 0 0 .726-.52l-.629-4.083 2.821-2.82a.5.5 0 0 0-.277-.848l-4.078-.628-1.718-3.435a.5.5 0 0 0-.444-.276Z"
    ></path>
  </svg>
);

// chevron ปุ่มกาง/ยุบ — ทิศคุมจาก className (rotate-180 ตอนกาง)
const IconChevronDown = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m5 7.5 5 5 5-5"
    ></path>
  </svg>
);

const IconUpload = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M11.985 3a1 1 0 0 0-.692.293l-3 3a1 1 0 1 0 1.414 1.414L11 6.414V15.5a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3A1 1 0 0 0 11.985 3M6 8.5c-1.645 0-3 1.355-3 3V18c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3v-6.5c0-1.645-1.355-3-3-3h-.5a1 1 0 1 0 0 2h.5c.564 0 1 .436 1 1V18c0 .564-.436 1-1 1H6c-.564 0-1-.436-1-1v-6.5c0-.564.436-1 1-1h.5a1 1 0 1 0 0-2z"
    ></path>
  </svg>
);

const IconDownload = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M10 12.083V3.75m0 8.333c-.583 0-1.674-1.662-2.083-2.083M10 12.083c.584 0 1.674-1.662 2.083-2.083M16.667 13.75c0 2.068-.432 2.5-2.5 2.5H5.833c-2.068 0-2.5-.432-2.5-2.5"
    ></path>
  </svg>
);

const IconAdd = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0 1.5c4.703 0 8.5 3.797 8.5 8.5s-3.797 8.5-8.5 8.5A8.49 8.49 0 0 1 3.5 12c0-4.703 3.797-8.5 8.5-8.5m-.012 3.49a.75.75 0 0 0-.738.76v3.5h-3.5a.751.751 0 1 0 0 1.5h3.5v3.5a.751.751 0 1 0 1.5 0v-3.5h3.5a.751.751 0 1 0 0-1.5h-3.5v-3.5a.75.75 0 0 0-.762-.76"
    ></path>
  </svg>
);

const IconCopyLink = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12.13 11.015A2.224 2.224 0 1 1 8.985 7.87l1.966-1.966a2.224 2.224 0 0 1 3.023-.113m-.27-2.64a2.224 2.224 0 1 1 3.145 3.146l-1.966 1.966c-.83.829-2.15.867-3.024.113"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8.75 2.5c-2.74 0-4.11 0-5.031.757a3.3 3.3 0 0 0-.462.462C2.5 4.64 2.5 6.01 2.5 8.749v2.084c0 3.143 0 4.714.976 5.69.977.977 2.548.977 5.69.977h2.084c2.74 0 4.11 0 5.031-.757q.254-.208.462-.462c.757-.922.757-2.291.757-5.031"
    ></path>
  </svg>
);

const IconDuplicate = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <rect
      className="transition-all duration-200 group-hover:translate-x-0.5 group-hover:translate-y-0.5 group-hover:fill-folio/10"
      x="6.25" y="6.25" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"
    />
    <path
      className="transition-all duration-200 group-hover:-translate-x-0.5 group-hover:-translate-y-0.5 group-hover:opacity-70"
      d="M13.75 6.25v-1.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h1.5"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
    />
  </svg>
);

const IconCopiedLink = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8.75 2.5c-2.74 0-4.11 0-5.031.757a3.3 3.3 0 0 0-.462.462C2.5 4.64 2.5 6.01 2.5 8.749v2.084c0 3.143 0 4.714.976 5.69.977.977 2.548.977 5.69.977h2.084c2.74 0 4.11 0 5.031-.757q.254-.208.462-.462c.757-.922.757-2.291.757-5.031"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m7 7.5 3.5 3.5L17 4"
    ></path>
  </svg>
);

const IconUpdate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="3"
    className="icon-update"
    viewBox="0 0 24 24"
  >
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
    <path d="M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
    <path d="M8 16H3v5"></path>
  </svg>
);

const IconChecked = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    className="icon-checked"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.791 18.75a8.958 8.958 0 1 1 0-17.917 8.958 8.958 0 0 1 0 17.917m3.974-10.925a.833.833 0 1 0-1.28-1.067l-3.583 4.3-1.855-1.856a.833.833 0 0 0-1.178 1.179l2.5 2.5a.833.833 0 0 0 1.23-.056z"
      clipRule="evenodd"
    ></path>
  </svg>
);

// ช่องคะแนนที่กรอกเอง (sync ไม่ได้) — ดินสอ = แก้ไข/ลบ, ต่างจาก IconUpdate ที่หมายถึงเชื่อมข้อมูลใหม่
const IconEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2.5"
    className="icon-edit"
    viewBox="0 0 24 24"
  >
    <path d="M21.17 6.81a2.83 2.83 0 0 0-4-4L3.84 16.17a2 2 0 0 0-.5.83l-1.32 4.35a.5.5 0 0 0 .62.62l4.35-1.32a2 2 0 0 0 .83-.5z"></path>
    <path d="m15 5 4 4"></path>
  </svg>
);

export {
  IconFolio,
  IconFolioStar,
  IconFolioStarOutline,
  IconChevronDown,
  IconUpload,
  IconAdd,
  IconDownload,
  IconDuplicate,
  IconCopyLink,
  IconCopiedLink,
  IconUpdate,
  IconChecked,
  IconEdit,
};
